import { useAtomValue } from "jotai";
import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";
import type { YouTubePlayer } from "youtube-player/dist/types";

import { AutoplayMode } from "~/components/scmp-youtube-video/scmp-youtube-video-player/enums";
import { onlyOnePlayingPlayerAtom } from "~/lib/only-one-playing-player";

type UseOnlyOneYoutubePlayerEffectParameters = {
  player: OrUndefined<YouTubePlayer>;
  setAutoplayMode: Dispatch<SetStateAction<AutoplayMode>>;
  uniqueVideoId: string;
};

/**
 * For ensure there is only one YouTube player playing the video
 */
export const useOnlyOneYoutubePlayerEffect = ({
  player,
  setAutoplayMode,
  uniqueVideoId,
}: UseOnlyOneYoutubePlayerEffectParameters) => {
  const { playingYoutubeId } = useAtomValue(onlyOnePlayingPlayerAtom);

  useEffect(() => {
    if (!playingYoutubeId || !player) return;
    if (uniqueVideoId !== playingYoutubeId) {
      // Need to set it to be autoplay pausing for preventing set manualPaused to true accidentally
      setAutoplayMode(AutoplayMode.Pausing);
      try {
        void player?.pauseVideo();
      } catch (error) {
        console.error("useOnlyOneYoutubePlayerEffect pauseVideo", error);
      }
    }
  }, [player, playingYoutubeId, setAutoplayMode, uniqueVideoId]);
};
